/**
 * Prevents propagation and clobbers the default action of the passed
 * event. The same as calling `event.preventDefault()` and
 * `event.stopPropagation()` on some passed event.
 */
export default function stopEvent(event) {
  event.stopPropagation();
  event.preventDefault();
}
//# sourceMappingURL=stopEvent.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@flowio/fraud/~/@flowio/browser-helpers/dist/esm/stopEvent.js
// module id = 583
// module chunks = 0 1